import { RouteObject } from 'react-router-dom';
import adminAuthRoutes from './auth';
import adminDashboardRoutes from './dashboard';

export const adminRoutes: RouteObject[] = [
  ...adminDashboardRoutes,
  ...adminAuthRoutes,
];
